// Reproductive-chain timeline: opu → clivage → t.e. → dx.
// Derives how far a session got from the list `counts` (api-reference
// admin-aspiration-sessions §?view=summary). The summary today only carries
// up to clivage (clivages_count); transfers/pregnancies are NOT in the list,
// so t.e./dx stay pending. Forward-compatible: if the backend later adds `fase`
// or transfer/pregnancy counts to the summary, those steps light up with no
// frontend change. Full funnel lives in /:id?view=resolution.

export const TIMELINE_STEPS = [
    { key: 'opu', label: 'OPU' },
    { key: 'clivage', label: 'Clivaje' },
    { key: 'te', label: 'T.E.' },
    { key: 'dx', label: 'Dx' },
];

// fase (resolution rollup) → furthest reached step index in the 4-step timeline.
const FASE_INDEX = {
    aspirada: 0,
    clivada: 1,
    con_embriones: 1,
    transferida: 2,
    'preñada': 3,
    prenada: 3,
    nacida: 3,
};

// Index of the furthest completed step (0 = OPU … 3 = Dx).
export function reachedStep(item) {
    if (!item) return 0;

    const fase = item.resolution?.fase || item.fase;
    if (fase && FASE_INDEX[fase] != null) return FASE_INDEX[fase];

    const c = item.counts || {};
    let idx = 0; // the session exists → OPU done
    if ((c.clivages_count || 0) > 0) idx = 1;
    if ((c.transfers_count || 0) > 0) idx = 2;                                  // not in summary yet
    if ((c.pregnancies_confirmed || 0) > 0 || (c.births_count || 0) > 0) idx = 3; // not in summary yet
    return idx;
}
